// Flatten Subscription Scopes
export const SubscriptionScopeKey = {
    // // Modules
    // sales: 'SALE',
    // purchases: 'PURCHASE',
    // banking: 'BANK', // TODO: remove once backend ready (BANK_INCOME_EXPENSE, BANK_TRANSFER)
    // shoebox: 'DIGITAL_SHOEBOX',
    // reports: 'REPORT',

    // 9/10: REMOVE THIS ONCE REPLACED THESE OLD KEYS WITH THE NEW ONES (DOT NOTATION) BELOW
    // // Analytics
    // DASHBOARD: 'DASHBOARD',
    // REPORT: 'REPORT',

    // // Sales
    // SALE: 'SALE',
    // // sales_batch: 'SALE_BATCH', // <--- removed 22 AUG 2023
    // SALE_PAYMENT_GATEWAY: 'SALE_PAYMENT_GATEWAY', // TODO: change api to SALE_PAYMENT_GATEWAY
    // SALE_LATE_INTEREST: 'SALE_LATE_INTEREST', // <--- new 22 AUG 2023
    // SALE_INVOICE_REMINDER: 'SALE_INVOICE_REMINDER', // <--- modified 22 AUG 2023 TODO: (INVOICE_REMINDER => SALE_INVOICE_REMINDER)

    // // Purchases
    // PURCHASE: 'PURCHASE',
    // // purchases_batch: 'PURCHASE_BATCH', // <--- removed 22 AUG 2023

    // // Banking
    // BANK_INCOME_EXPENSE: 'BANK_INCOME_EXPENSE',
    // // bank_income_expense_batch: 'BANK_INCOME_EXPENSE_BATCH',  // <--- removed 22 AUG 2023
    // BANK_TRANSFER: 'BANK_TRANSFER',
    // // bank_reconciliation: 'BANK_RECONCILIATION', // removed TODO: change api to BANK_MANUAL_RECONCILIATION + BANK_SMART_RECONCILIATION
    // BANK_RECONCILIATION_MANUAL: 'BANK_RECONCILIATION_MANUAL', // <--- new 22 AUG 2023
    // BANK_RECONCILIATION_SMART: 'BANK_RECONCILIATION_SMART', // <--- new 22 AUG 2023

    // // All Transactions
    // TRANSACTION_BATCH: 'TRANSACTION_BATCH', // <--- new 22 AUG 2023
    // TRANSACTION_SHOEBOX: 'TRANSACTION_SHOEBOX',
    // TRANSACTION_E_INVOICING: 'TRANSACTION_E_INVOICING',
    // TRANSACTION_INSTRUCTION_CONTACT: 'TRANSACTION_INSTRUCTION_CONTACT',
    // TRANSACTION_INSTRUCTION_CONTACT_GROUP: 'TRANSACTION_INSTRUCTION_CONTACT_GROUP',

    // // Contacts
    // CONTACT: 'CONTACT',
    // CONTACT_IMPORT: 'CONTACT_IMPORT', // <--- new 22 AUG 2023
    // CONTACT_GROUP: 'CONTACT_GROUP',
    // CONTACT_STATEMENT: 'CONTACT_STATEMENT', // <--- new 22 AUG 2023
    // CONTACT_E_STATEMENT: 'CONTACT_E_STATEMENT',
    // CONTACT_E_STATEMENT_AUTO: 'CONTACT_E_STATEMENT_AUTO',

    // // Products & Services
    // PRODUCT: 'PRODUCT',
    // PRODUCT_IMPORT: 'PRODUCT_IMPORT', // <--- new 22 AUG 2023
    // PRODUCT_BUNDLE: 'PRODUCT_BUNDLE',
    // PRODUCT_GROUP: 'PRODUCT_GROUP',
    // PRODUCT_MULTI_UOM: 'PRODUCT_MULTI_UOM',
    // PRODUCT_MULTI_PRICE: 'PRODUCT_MULTI_PRICE', //  <--- new 22 AUG 2023

    // // Inventory Tracking
    // STOCK: 'STOCK',
    // STOCK_MULTI_LOCATION: 'STOCK_MULTI_LOCATION',
    // STOCK_ADJUSTMENT: 'STOCK_ADJUSTMENT', // <--- new 22 AUG 2023
    // STOCK_TRANSFER: 'STOCK_TRANSFER', // <--- new 22 AUG 2023

    // // Accounting & Tax
    // ACCOUNTING_JOURNAL_ENTRY: 'ACCOUNTING_JOURNAL_ENTRY',
    // ACCOUNTING_CONTRA: 'ACCOUNTING_CONTRA',
    // ACCOUNTING_ACCOUNT: 'ACCOUNTING_ACCOUNT',
    // ACCOUNTING_ACCOUNT_IMPORT: 'ACCOUNTING_ACCOUNT_IMPORT', // <--- new 22 AUG 2023
    // ACCOUNTING_FIXED_ASSET: 'ACCOUNTING_FIXED_ASSET',
    // TAX_SST: 'TAX_SST',

    // // Other Features
    // MULTI_NUMBER_FORMAT: 'MULTI_NUMBER_FORMAT',
    // MULTI_FORM_DESIGN: 'MULTI_FORM_DESIGN',
    // MULTI_CURRENCY: 'MULTI_CURRENCY',
    // CUSTOM_FIELD: 'CUSTOM_FIELD',
    // PRICE_LEVEL: 'PRICE_LEVEL',
    // TAG: 'TAG',
    // // permission: 'PERMISSION', // <-- removed 22 AUG 2023
    // USER_PERMISSION_LEVEL_1: 'USER_PERMISSION_LEVEL_1', // <-- new 22 AUG 2023
    // USER_PERMISSION_LEVEL_2: 'USER_PERMISSION_LEVEL_2', // <-- new 22 AUG 2023
    // STORE: 'STORE',
    // LIVE_CHAT: 'LIVE_CHAT', // <-- new 22 AUG 2023

    // // custom_fields: 'manage_custom_field',

    // // Integrations
    // // payroll: 'PAYROLL', // TODO: change to INTEGRATION_PAYROLL
    // INTEGRATION_PAYROLL: 'INTEGRATION_PAYROLL', // <-- TODO: updated 22 AUG 2023 - change to INTEGRATION_PAYROLL
    // INTEGRATION_OPEN_API: 'INTEGRATION_OPEN_API', // <-- new 22 AUG 2023 - change to INTEGRATION_PAYROLL

    // // Specific Modules
    // sales_batch: 'SALE_BATCH',
    // purchases_batch: 'PURCHASE_BATCH',
    // batch_bank: 'BANK_BATCH', // TODO: remove once backend ready (BANK_INCOME_EXPENSE_BATCH, BANK_TRANSFER_BATCH)
    // bank_reconciliation: 'BANK_RECONCILIATION',
    // journal_entry: 'ACCOUNTING_JOURNAL_ENTRY',
    // asset: 'ASSET',
    // instruction: 'INSTRUCTION', // TODO: remove once backend ready (INSTRUCTION_CONTACT, INSTRUCTION_CONTACT_GROUP)

    // tag: 'TAG',
    // custom_fields: 'FIELD',

    // inventory_tracking: 'PRODUCT_INVENTORY',
    // email_tracker: 'EMAIL_TRACKER', // TODO: remove once backend ready (deprecated)
    // e_invoicing: 'E_INVOICING',
    // invoice_reminder: 'INVOICE_REMINDER',
    // // payment_gateway: 'PAYMENT_GATEWAY',
    // sst: 'TAX_SST', // TODO: remove once backend ready (deprecated)

    // // Multi-based
    // multi_location: 'PRODUCT_INVENTORY_MULTI_LOCATION',
    // multi_uom: 'PRODUCT_MULTI_UOM',
    // multi_price_level: 'PRODUCT_MULTI_PRICE',
    // multi_currency: 'MULTI_CURRENCY',
    // multi_user: 'MULTI_USER',
    // multi_number: 'MULTI_NUMBER_FORMAT',
    // multi_form_design: 'MULTI_FORM_DESIGN',

    // ----- NEW ----- //
    // 26/6/25: Reorganized to follow backend FeatureHelper.php order
    DASHBOARD: "DASHBOARD",
    REPORT: "REPORT",
    ADVANCED_REPORTING_TOOLS: "ADVANCED_REPORTING_TOOLS",

    SALE: "SALE",
    "SALE.PAYMENT_GATEWAY": "SALE.PAYMENT_GATEWAY",
    "SALE.LATE_INTEREST": "SALE.LATE_INTEREST",
    "SALE.INVOICE_REMINDER": "SALE.INVOICE_REMINDER",

    PURCHASE: "PURCHASE",

    "BANK.TRANSACTION": "BANK.TRANSACTION",
    "BANK.RECONCILIATION.MANUAL": "BANK.RECONCILIATION.MANUAL",
    "BANK.RECONCILIATION.AUTO": "BANK.RECONCILIATION.AUTO",
    "BANK.BANK_FEED": "BANK.BANK_FEED",

    "ACCOUNTING.JOURNAL_ENTRY": "ACCOUNTING.JOURNAL_ENTRY",
    "ACCOUNTING.CONTRA": "ACCOUNTING.CONTRA",
    "ACCOUNTING.ACCOUNT_BULK_IMPORT": "ACCOUNTING.ACCOUNT_BULK_IMPORT",
    "ACCOUNTING.FIXED_ASSET": "ACCOUNTING.FIXED_ASSET",

    "TAX.SST": "TAX.SST",
    MULTI_CURRENCY: "MULTI_CURRENCY",

    TRANSACTION: "TRANSACTION",
    "TRANSACTION.ITEM_TRANSFER": "TRANSACTION.ITEM_TRANSFER",
    "TRANSACTION.BULK_CREATE": "TRANSACTION.BULK_CREATE",
    "TRANSACTION.BULK_IMPORT": "TRANSACTION.BULK_IMPORT",
    "TRANSACTION.QUICKSHARE": "TRANSACTION.QUICKSHARE", // previously 'TRANSACTION.E_INVOICE'
    "TRANSACTION.QUICKSHARE.EMAIL_TRACKER": "TRANSACTION.QUICKSHARE.EMAIL_TRACKER",
    "TRANSACTION.SHOEBOX": "TRANSACTION.SHOEBOX",
    "TRANSACTION.REQUEST_E_INVOICE": "TRANSACTION.REQUEST_E_INVOICE",
    "TRANSACTION.INSTRUCTION": "TRANSACTION.INSTRUCTION",
    "TRANSACTION.INSTRUCTION.CONTACT_GROUP": "TRANSACTION.INSTRUCTION.CONTACT_GROUP",

    CONTACT: "CONTACT",
    "CONTACT.BULK_IMPORT": "CONTACT.BULK_IMPORT",
    "CONTACT.BULK_UPDATE": "CONTACT.BULK_UPDATE",
    "CONTACT.GROUP": "CONTACT.GROUP",
    "CONTACT.STATEMENT": "CONTACT.STATEMENT",
    "CONTACT.STATEMENT.E_STATEMENT": "CONTACT.STATEMENT.E_STATEMENT",
    "CONTACT.STATEMENT.E_STATEMENT.AUTO": "CONTACT.STATEMENT.E_STATEMENT.AUTO",
    "CONTACT.STATEMENT.E_STATEMENT.EMAIL_TRACKER": "CONTACT.STATEMENT.E_STATEMENT.EMAIL_TRACKER",

    PRODUCT: "PRODUCT",
    "PRODUCT.BULK_IMPORT": "PRODUCT.BULK_IMPORT",
    "PRODUCT.GROUP": "PRODUCT.GROUP",
    "PRODUCT.BUNDLE": "PRODUCT.BUNDLE",
    "PRODUCT.MULTI_UOM": "PRODUCT.MULTI_UOM",
    "PRODUCT.CUSTOM_PRICE": "PRODUCT.CUSTOM_PRICE",

    INVENTORY: "INVENTORY",
    "INVENTORY.STOCK_ADJUSTMENT": "INVENTORY.STOCK_ADJUSTMENT",
    "INVENTORY.MULTI_LOCATION": "INVENTORY.MULTI_LOCATION",
    "INVENTORY.STOCK_TRANSFER": "INVENTORY.STOCK_TRANSFER",

    MULTI_NUMBER_FORMAT: "MULTI_NUMBER_FORMAT",
    MULTI_FORM_DESIGN: "MULTI_FORM_DESIGN",
    CUSTOM_FIELD: "CUSTOM_FIELD",
    TAG: "TAG",
    USER_PERMISSION: "USER_PERMISSION",
    "USER_PERMISSION.ADVANCED": "USER_PERMISSION.ADVANCED",
    PRICE_LEVEL: "PRICE_LEVEL",

    "INTEGRATION.PAYROLL": "INTEGRATION.PAYROLL",
    "INTEGRATION.OPEN_API": "INTEGRATION.OPEN_API",
    FLOW: "FLOW",

    STORE: "STORE",
    MINIPOS: "MINIPOS",
    LIVE_CHAT: "LIVE_CHAT",
};
